<script>
  import { getContext } from "svelte";
  import { languagesStore } from "../store/Languages.js";

  const { close } = getContext("modal");
  const { snackbar } = getContext("app");
  function closeModal() {
    close();
  }
  export let callback;
  export let lang = { isRtl: false, langName: "" };
  async function save() {
    if (lang.langName == "") {
      snackbar("info", "Fill in a name  for the language");
      return;
    }
    var result = await languagesStore.saveLang(lang);
    callback();
    if (result.success) {
      snackbar("info", "Lang saved");
      close();
    } else {
      snackbar("error", result.message);
    }
  }

  function init(element) {
    element.focus();
  }
</script>

<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel">Language</h5>
</div>
<div class="modal-body">
  <label for="naam">Language name</label>
  <input
    type="text"
    class="form-control"
    placeholder="Language name "
    bind:value={lang.langName}
    use:init
    required=""
    id="naam"
  />
  <label for="locale">Language culture for date</label>
  <input
    type="text"
    class="form-control"
    placeholder="Language name "
    bind:value={lang.locale}
    required=""
    id="locale"
  />
  <div class="custom-control custom-checkbox mb-3">
    <input
      type="checkbox"
      id="isRtl"
      class="custom-control-input"
      bind:checked={lang.isRtl}
    />

    <label for="isRtl" class="custom-control-label">
      is RTL (right to left)
    </label>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" on:click={closeModal}>
    Close
  </button>
  <button type="button" class="btn btn-primary" on:click={save}>Save</button>
</div>
